import { createFileRoute } from "@tanstack/react-router";

import { Participant } from "@/pages/participant";

export const Route = createFileRoute("/participate/$session_token/")({
  component: Participant,
});
